module.exports = __webpack_public_path__ + "09a00f75d40d91a00f2bfb85f9af5c50.svg";